import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Handbook from 'containers/Handbook';
import Success from 'containers/Success';
import App from 'containers/App';

/**
 * The 'Routes' component, containing all of the higher routes.
 *
 * @method      Routes
 * @constructor
 */
function Routes() {
    return (
        <Switch>
            <Route exact path="/handbook" component={Handbook} />
            <Route exact path="/success" component={Success} />
            <Route exact path="/" component={App} />
            <Redirect to="/" />
        </Switch>
    );
}

export default Routes;
